// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AgentBackupData, AgentBackupErrors, AgentBackupResponses, AgentHeartbeatData, AgentHeartbeatErrors, AgentHeartbeatResponses, AgentManifestData, AgentManifestErrors, AgentManifestResponses, AppConfigGetStatusData, AppConfigGetStatusErrors, AppConfigGetStatusResponses, BackofficeAuthAcceptInviteData, BackofficeAuthAcceptInviteErrors, BackofficeAuthAcceptInviteResponses, BackofficeAuthChangePasswordData, BackofficeAuthChangePasswordErrors, BackofficeAuthChangePasswordResponses, BackofficeAuthCreateAdminData, BackofficeAuthCreateAdminErrors, BackofficeAuthCreateAdminResponses, BackofficeAuthDeleteAdminData, BackofficeAuthDeleteAdminErrors, BackofficeAuthDeleteAdminResponses, BackofficeAuthGetMeData, BackofficeAuthGetMeErrors, BackofficeAuthGetMeResponses, BackofficeAuthGetSessionData, BackofficeAuthGetSessionErrors, BackofficeAuthGetSessionResponses, BackofficeAuthListAdminsData, BackofficeAuthListAdminsErrors, BackofficeAuthListAdminsResponses, BackofficeAuthRequestPasswordResetData, BackofficeAuthRequestPasswordResetErrors, BackofficeAuthRequestPasswordResetResponses, BackofficeAuthResendInviteData, BackofficeAuthResendInviteErrors, BackofficeAuthResendInviteResponses, BackofficeAuthResetPasswordData, BackofficeAuthResetPasswordErrors, BackofficeAuthResetPasswordResponses, BackofficeAuthSendChangePasswordOtpData, BackofficeAuthSendChangePasswordOtpErrors, BackofficeAuthSendChangePasswordOtpResponses, BackofficeAuthSignInWithEmailData, BackofficeAuthSignInWithEmailErrors, BackofficeAuthSignInWithEmailResponses, BackofficeAuthSignOutData, BackofficeAuthSignOutErrors, BackofficeAuthSignOutResponses, BackofficeAuthUpdateAdminAbilitiesData, BackofficeAuthUpdateAdminAbilitiesErrors, BackofficeAuthUpdateAdminAbilitiesResponses, BackofficeAuthUpdateMeData, BackofficeAuthUpdateMeErrors, BackofficeAuthUpdateMeResponses, DocsSchemaData, DocsSchemaErrors, HealthCheckData, HealthCheckErrors, HealthCheckResponses, HealthCheckServicesData, HealthCheckServicesErrors, PoAcceptProposalData, PoAcceptProposalErrors, PoAcceptProposalResponses, PoBulkAcceptProposalsData, PoBulkAcceptProposalsErrors, PoBulkAcceptProposalsResponses, PoCorrectProposalData, PoCorrectProposalErrors, PoCorrectProposalResponses, PoCreateExclusivityYearData, PoCreateExclusivityYearErrors, PoCreateExclusivityYearResponses, PoCreateExportData, PoCreateExportErrors, PoCreateExportResponses, PoCreateRunData, PoCreateRunErrors, PoCreateRunResponses, PoGetConfigData, PoGetConfigErrors, PoGetConfigResponses, PoGetCorrectionsData, PoGetCorrectionsErrors, PoGetCorrectionsResponses, PoGetExclusivityYearsData, PoGetExclusivityYearsErrors, PoGetExclusivityYearsResponses, PoGetExportDownloadData, PoGetExportDownloadErrors, PoGetExportDownloadResponses, PoGetGenerationDefaultsData, PoGetGenerationDefaultsErrors, PoGetGenerationDefaultsResponses, PoGetProposalHistoryData, PoGetProposalHistoryErrors, PoGetProposalHistoryResponses, PoGetProposalsData, PoGetProposalsErrors, PoGetProposalsResponses, PoGetRunsData, PoGetRunsErrors, PoGetRunsResponses, PoGetSystemStatusData, PoGetSystemStatusErrors, PoGetSystemStatusResponses, PoListCorrectionFilterOptionsData, PoListCorrectionFilterOptionsErrors, PoListCorrectionFilterOptionsResponses, PoListCorrectionsData, PoListCorrectionsErrors, PoListCorrectionsResponses, PoListDistributorsData, PoListDistributorsErrors, PoListDistributorsResponses, PoListExportAuthorsData, PoListExportAuthorsErrors, PoListExportAuthorsResponses, PoListExportsData, PoListExportsErrors, PoListExportsResponses, PoListProposalsData, PoListProposalsErrors, PoListProposalsResponses, PoListPublishersData, PoListPublishersErrors, PoListPublishersResponses, PoListRunsData, PoListRunsErrors, PoListRunsResponses, PoRefreshDataData, PoRefreshDataErrors, PoRefreshDataResponses, PoRenameRunData, PoRenameRunErrors, PoRenameRunResponses, PoUpdateConfigData, PoUpdateConfigErrors, PoUpdateConfigResponses, PoUpdateCorrectionReviewData, PoUpdateCorrectionReviewErrors, PoUpdateCorrectionReviewResponses, PoUpdateExclusivityPublisherData, PoUpdateExclusivityPublisherErrors, PoUpdateExclusivityPublisherResponses, PoUpdateRunStatusData, PoUpdateRunStatusErrors, PoUpdateRunStatusResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Schema
 *
 * Returns the OpenAPI JSON schema
 */
export const docsSchema = <ThrowOnError extends boolean = true>(options?: Options<DocsSchemaData, ThrowOnError>) => (options?.client ?? client).get<unknown, DocsSchemaErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/docs/schema',
    ...options
});

/**
 * Heartbeat
 *
 * Agent liveness ping and command channel. Called frequently (every minute) so operator actions like “refresh data now” and agent updates stay reactive. Authenticated by the per-agent token in the `X-Agent-Token` header. Returns any queued `commands` to execute now; report their outcome via `acknowledgements` on a later call.
 */
export const agentHeartbeat = <ThrowOnError extends boolean = true>(options: Options<AgentHeartbeatData, ThrowOnError>) => (options.client ?? client).post<AgentHeartbeatResponses, AgentHeartbeatErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/agent/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Manifest
 *
 * Closes a sync round and records the outcome of every table the agent is configured to sync: `stored`, `already_present`, `unchanged` (confirmed at `sha256`) or `failed` (with a `reason`). Send it after uploading the round's tables with the same round id; a round with no uploads is closed too. A round in which a table the documents need (libri, movim, editore, distrib) failed, or that does not list it (recorded as `failed`), closes anyway but is not a complete round, and does not move the agent's last complete sync time. Documents read the tables as of the last complete round: what a round stores enters them only once this call closes it. Idempotent: resending the manifest of a closed round keeps its first close and its first outcomes. A manifest without `tables` (agent 1.0) is refused with `validation_error`. Authenticated by the `X-Agent-Token` header. `commands` is always empty: queued commands are delivered on `heartbeat`.
 */
export const agentManifest = <ThrowOnError extends boolean = true>(options: Options<AgentManifestData, ThrowOnError>) => (options.client ?? client).post<AgentManifestResponses, AgentManifestErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/agent/manifest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Backup
 *
 * Receives one Mr.Book table (a gzipped DBF plus, when present, its gzipped FPT memo file) with its metadata. Idempotent by content hash for stored content: re-sending a table already stored stores nothing new (`already_present`), also when two uploads of it race. Every upload opens its round (by `clientRoundId`) or marks it active: the round is a sync in progress until its manifest closes it. The table is validated on arrival — an unreadable archive, a content hash that does not match `sha256`, or a bad header, size or record-count is `rejected` with a reason and NOT ingested, so the agent resends; a rejected content is validated again on every resend. When the server has lost the stored archive of a content (after a restore of its database), the bytes of the upload restore it and the answer is still `already_present`. A field that cannot be read — `recordCount` or `byteSize` not a non-negative integer, `sha256` not 64 lowercase hex characters, `mtime` not an ISO-8601 instant with its offset, an over-long `tableName` or `clientRoundId` — is `malformed_backup_upload` and nothing is stored. Authenticated by the `X-Agent-Token` header. `commands` is always empty: queued commands are delivered on `heartbeat`.
 */
export const agentBackup = <ThrowOnError extends boolean = true>(options?: Options<AgentBackupData, ThrowOnError>) => (options?.client ?? client).post<AgentBackupResponses, AgentBackupErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/agent/backup',
    ...options
});

/**
 * Get Status
 *
 * Returns the maintenance status and, while maintenance is active, its message and retry delay. Public and available during maintenance.
 */
export const appConfigGetStatus = <ThrowOnError extends boolean = true>(options?: Options<AppConfigGetStatusData, ThrowOnError>) => (options?.client ?? client).post<AppConfigGetStatusResponses, AppConfigGetStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/app-config/get-status',
    ...options
});

/**
 * Sign In With Email
 *
 * Signs an existing back-office admin in with `email` and `password`. Public; no authentication required. Never creates an account — admins are invite-only. On success the response carries the new session (token, `csrfToken`, expiry), the admin, and the abilities granted to them; browsers also receive the session as a cookie. To avoid leaking which addresses are registered, an unknown email, a wrong password, and an admin with no password all return the same error. Rate-limited per client address and per account (only failed attempts count against the account): past either limit you receive 429 `backoffice_rate_limited` with `retryAfterSeconds`.
 */
export const backofficeAuthSignInWithEmail = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignInWithEmailData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignInWithEmailResponses, BackofficeAuthSignInWithEmailErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-in-with-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Password Reset
 *
 * Emails a single-use reset link, valid for five minutes. Public and enumeration-safe: unknown addresses receive the same success response without sending email. A reset requested less than a minute ago returns 429 with retryAfterSeconds; requests are also rate-limited per client address.
 */
export const backofficeAuthRequestPasswordReset = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthRequestPasswordResetData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthRequestPasswordResetResponses, BackofficeAuthRequestPasswordResetErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/request-password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Password
 *
 * Consumes the single-use token from request-password-reset, changes the password and issues a session with admin identity and abilities. By default every other session is revoked; set revokeOtherSessions to false to keep them. Public and rate-limited per client address (429 backoffice_rate_limited).
 */
export const backofficeAuthResetPassword = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthResetPasswordData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthResetPasswordResponses, BackofficeAuthResetPasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Password
 *
 * Changes the authenticated admin's password. Use current-password when a password is set; otherwise a verified email and an OTP from send-change-password-otp are required. A method that does not match the account is rejected. Other sessions are revoked by default; revokeOtherSessions: false keeps them. The current session is preserved.
 */
export const backofficeAuthChangePassword = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthChangePasswordData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthChangePasswordResponses, BackofficeAuthChangePasswordErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Change Password Otp
 *
 * Emails a single-use, time-limited code to the authenticated admin's verified email that authorizes a password change from inside an active session. The code is delivered to the address on file (none is taken from the request), valid for 5 minutes, single-use, and bound to the calling admin — submit it to `change-password` with `type: "otp"`. The response also carries the signed `emailOtpToken` companion the admin must echo back at `change-password` together with the typed code — without it the code is not redeemable. Requesting a new code invalidates any earlier one (and the matching `emailOtpToken` must come from the same call). Returns 400 when the admin has no verified email, and 429 with `retryAfterSeconds` when a code was issued less than a minute ago.
 */
export const backofficeAuthSendChangePasswordOtp = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSendChangePasswordOtpData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSendChangePasswordOtpResponses, BackofficeAuthSendChangePasswordOtpErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/send-change-password-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Admin
 *
 * Invites a new back-office admin: creates the account (no password yet) with the given `abilities` and emails an invite link to set a password via `accept-invite`. Requires the `admins.manage` ability. Returns the created admin. Rejects a duplicate email with 409.
 */
export const backofficeAuthCreateAdmin = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthCreateAdminData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthCreateAdminResponses, BackofficeAuthCreateAdminErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/create-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Invite
 *
 * Accepts an admin invite: sets the admin's `password` (and optional `name`), confirms the email, and signs them straight in — the response carries the session, admin, and abilities. Public; the invite `token` is the proof. A consumed, expired, or unknown token is rejected. Rate-limited per client address: past the limit you receive 429 `backoffice_rate_limited` with `retryAfterSeconds`.
 */
export const backofficeAuthAcceptInvite = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthAcceptInviteData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthAcceptInviteResponses, BackofficeAuthAcceptInviteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/accept-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Invite
 *
 * Re-sends the invite email to a pending admin (one who has not yet accepted). Requires the `admins.manage` ability. Rejects with 400 when the admin has already accepted (use the password reset flow instead) and 404 when no such admin exists.
 */
export const backofficeAuthResendInvite = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthResendInviteData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthResendInviteResponses, BackofficeAuthResendInviteErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/resend-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Admins
 *
 * List back-office admins, one page at a time. Requires the `admins.manage` ability. Narrow results with `filters` (an explicit `ids` list to fetch a known set or a single admin, free-text `search` over name and email that also matches a full admin id pasted in, an `abilities` set matched as any-of, a `disabled` state, and a derived lifecycle `status`) and order them with `sort`. Read `meta` for the total count and total page count, and request successive `page` values to page through the result. Deleted admins are never returned.
 */
export const backofficeAuthListAdmins = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthListAdminsData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthListAdminsResponses, BackofficeAuthListAdminsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Admin Abilities
 *
 * Replace an admin's abilities with exactly the given set (any ability not listed is revoked). Requires the `admins.manage` ability. You cannot change your own abilities. Returns the updated admin.
 */
export const backofficeAuthUpdateAdminAbilities = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthUpdateAdminAbilitiesData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthUpdateAdminAbilitiesResponses, BackofficeAuthUpdateAdminAbilitiesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-admin-abilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Admin
 *
 * Delete the admins in `ids` and return no content. Requires the `admins.manage` ability. Deleting an admin ends all their sessions and frees their email for re-invitation. You cannot delete your own account. All-or-nothing: if any id is unknown (or already deleted) nothing is deleted and the request is rejected.
 */
export const backofficeAuthDeleteAdmin = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthDeleteAdminData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthDeleteAdminResponses, BackofficeAuthDeleteAdminErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/delete-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Me
 *
 * Return the authenticated admin's own profile (id, email, and display name) together with the `abilities` granted to them for client-side UI gating. Authenticated admins only; the account is resolved from the session. Use `update-me` to change the editable fields (name).
 */
export const backofficeAuthGetMe = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthGetMeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthGetMeResponses, BackofficeAuthGetMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/get-me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Me
 *
 * Update the authenticated admin's own profile and return the updated record. Admins only; the account is resolved from the session. Only `name` can be changed — fields you omit stay as they are. To change your password use `change-password`.
 */
export const backofficeAuthUpdateMe = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthUpdateMeData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthUpdateMeResponses, BackofficeAuthUpdateMeErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Session
 *
 * Returns the caller's back-office auth context: `sessionType` is `unauthenticated` when no valid session is present and `authenticated` otherwise, with the `session`, `admin`, and `abilities` blocks populated. The `admin` block is the auth identity only (`id`); fetch the full profile (email, name) via `get-me`. Public; works with or without credentials, so it is the endpoint to call on app start or after a reload to recover the signed-in state. When authenticated it also returns a fresh `csrfToken` for later mutating requests.
 */
export const backofficeAuthGetSession = <ThrowOnError extends boolean = true>(options?: Options<BackofficeAuthGetSessionData, ThrowOnError>) => (options?.client ?? client).post<BackofficeAuthGetSessionResponses, BackofficeAuthGetSessionErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/get-session',
    ...options
});

/**
 * Sign Out
 *
 * Ends a back-office session and clears the session cookie. Public and idempotent: pass the session's `token` in the body, or rely on the session cookie together with a valid `x-csrf-token` header. When no recognised credentials are present it is a no-op. Always succeeds.
 */
export const backofficeAuthSignOut = <ThrowOnError extends boolean = true>(options: Options<BackofficeAuthSignOutData, ThrowOnError>) => (options.client ?? client).post<BackofficeAuthSignOutResponses, BackofficeAuthSignOutErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/backoffice-auth/sign-out',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Corrections
 *
 * Elenca l'ultima correzione di ogni riga, anche nei PO completati o archiviati. Tutti gli admin autenticati possono leggere. Filtra per documento, stato della valutazione, autore e periodo della correzione. Senza runId legge tutti i documenti. Nessuno stato è filtrato implicitamente; ordinamento predefinito per correzione più recente, con id stabile a parità. Ricerca letterale su titolo, ISBN, codici, motivazione e note tecniche.
 */
export const poListCorrections = <ThrowOnError extends boolean = true>(options: Options<PoListCorrectionsData, ThrowOnError>) => (options.client ?? client).post<PoListCorrectionsResponses, PoListCorrectionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-corrections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Corrections
 *
 * Rilegge le ultime correzioni per id di riga, con versione corrente per il salvataggio della valutazione. Omette gli id inesistenti o mai corretti. Tutti gli admin autenticati possono leggere.
 */
export const poGetCorrections = <ThrowOnError extends boolean = true>(options: Options<PoGetCorrectionsData, ThrowOnError>) => (options.client ?? client).post<PoGetCorrectionsResponses, PoGetCorrectionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-corrections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Correction Filter Options
 *
 * Documenti e autori distinti presenti nelle correzioni, anche di PO storici, completati e archiviati. Tutti gli admin autenticati possono leggere. runId limita le opzioni al documento; gli altri filtri della lista non le restringono. Nessun caricamento di righe o dettagli del calcolo. I campi deprecati publishers e distributors restano vuoti per i client precedenti.
 */
export const poListCorrectionFilterOptions = <ThrowOnError extends boolean = true>(options: Options<PoListCorrectionFilterOptionsData, ThrowOnError>) => (options.client ?? client).post<PoListCorrectionFilterOptionsResponses, PoListCorrectionFilterOptionsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-correction-filter-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Correction Review
 *
 * Salva stato e note tecniche della correzione. Richiede corrections.manage; admins.manage da solo non basta. Consentito anche nei documenti completati e archiviati, senza modificare quantità, stato o data del PO. expectedVersion deve corrispondere alla versione letta: una correzione o valutazione concorrente restituisce correction_review_conflict (409), senza sovrascrivere nulla. ok significa intervento già implementato; ko nessun intervento; pending lavoro ancora aperto. Una nuova correzione effettiva riapre pending conservando le note.
 */
export const poUpdateCorrectionReview = <ThrowOnError extends boolean = true>(options: Options<PoUpdateCorrectionReviewData, ThrowOnError>) => (options.client ?? client).post<PoUpdateCorrectionReviewResponses, PoUpdateCorrectionReviewErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/update-correction-review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Runs
 *
 * Elenca i documenti di proposta (l'indice, stile home di fogli di calcolo), per default ordinati per ultima modifica, che comprende le decisioni dell'esperto sulle righe; ordinabili con `sort`. I documenti passati restano sempre qui: l'indice è lo storico delle campagne. Richiede un account autenticato. Filtra per nome con `filters.search`.
 */
export const poListRuns = <ThrowOnError extends boolean = true>(options: Options<PoListRunsData, ThrowOnError>) => (options.client ?? client).post<PoListRunsResponses, PoListRunsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Run
 *
 * Crea un nuovo documento di proposta e avvia la generazione (“Genera proposte”). L'anno di campagna è derivato dal calendario al momento della creazione, senza cerimonia. La generazione è asincrona: il documento nasce `pending` e va monitorato con `get-runs` finché diventa `in_progress` o `failed`. Una sola generazione alla volta: mentre un'altra è in corso risponde `run_already_in_progress`; una generazione interrotta (riavvio, crash) viene chiusa come `failed` entro 17 minuti dal suo avvio. Il documento si genera sui dati dell'ultimo giro di sincronizzazione chiuso e completo dell'agente, anche mentre un aggiornamento dati è in corso: le tabelle di un giro non ancora chiuso non entrano. Senza un giro completo risponde `no_complete_dataset`; se a quel giro manca una tabella indispensabile, `dataset_not_ready`. Se il servizio di elaborazione non è raggiungibile risponde `job_queue_unavailable`: il documento appena creato è già `failed` con il motivo e non blocca una nuova generazione, che si può richiedere più tardi (se la generazione era partita comunque, il documento prosegue normalmente). Richiede un account autenticato.
 */
export const poCreateRun = <ThrowOnError extends boolean = true>(options: Options<PoCreateRunData, ThrowOnError>) => (options.client ?? client).post<PoCreateRunResponses, PoCreateRunErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/create-run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Runs
 *
 * Legge uno o più documenti di proposta per id, con lo stato di generazione, l'avanzamento della revisione e le ripartizioni per editore e distributore. Usalo anche per il polling durante una generazione in corso. Richiede un account autenticato.
 */
export const poGetRuns = <ThrowOnError extends boolean = true>(options: Options<PoGetRunsData, ThrowOnError>) => (options.client ?? client).post<PoGetRunsResponses, PoGetRunsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rename Run
 *
 * Rinomina un documento di proposta (come si rinomina un file). Richiede un account autenticato.
 */
export const poRenameRun = <ThrowOnError extends boolean = true>(options: Options<PoRenameRunData, ThrowOnError>) => (options.client ?? client).post<PoRenameRunResponses, PoRenameRunErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/rename-run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Run Status
 *
 * Fa avanzare un documento nel flusso di lavoro: in lavorazione -> completato -> archiviato; si archivia anche un documento ancora in lavorazione o fallito. Completare richiede che ogni riga sia stata rivista. Entrambe le transizioni sono definitive — un documento completato non si riapre e uno archiviato non si ripristina, se ne genera uno nuovo — quindi falle confermare sempre all'utente. Chiedere lo stato che il documento ha già non cambia nulla; due richieste contemporanee sullo stesso documento vengono servite una dopo l'altra, e la seconda trova lo stato lasciato dalla prima. Richiede un account autenticato.
 */
export const poUpdateRunStatus = <ThrowOnError extends boolean = true>(options: Options<PoUpdateRunStatusData, ThrowOnError>) => (options.client ?? client).post<PoUpdateRunStatusResponses, PoUpdateRunStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/update-run-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Proposals
 *
 * Elenca le righe di un documento di proposta, una pagina alla volta (la griglia di revisione). L'ordinamento di default è per priorità: righe segnalate in cima. Nessun filtro è attivo di default: ogni titolo dell'universo compare. In ogni riga `details` porta solo la parte del calcolo che la griglia mostra: il calcolo completo si legge con `get-proposals`. La ricerca trova `%`, `_` e `\` alla lettera. Richiede un account autenticato.
 */
export const poListProposals = <ThrowOnError extends boolean = true>(options: Options<PoListProposalsData, ThrowOnError>) => (options.client ?? client).post<PoListProposalsResponses, PoListProposalsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Proposals
 *
 * Legge una o più righe di proposta per id, con il dettaglio completo del calcolo (motivazione, disponibilità, segnalazioni) e la memoria delle campagne passate sullo stesso titolo. Richiede un account autenticato.
 */
export const poGetProposals = <ThrowOnError extends boolean = true>(options: Options<PoGetProposalsData, ThrowOnError>) => (options.client ?? client).post<PoGetProposalsResponses, PoGetProposalsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Proposal
 *
 * Accetta la quantità proposta per una riga (un click). L'azione è tracciata nella cronologia della riga e reversibile con una successiva correzione. Si accetta solo una riga ancora da rivedere: su una riga già accettata risponde con la riga invariata, su una riga corretta nel frattempo rifiuta con `proposal_already_corrected`. Su un documento non più in lavorazione risponde `run_not_editable`. Richiede un account autenticato.
 */
export const poAcceptProposal = <ThrowOnError extends boolean = true>(options: Options<PoAcceptProposalData, ThrowOnError>) => (options.client ?? client).post<PoAcceptProposalResponses, PoAcceptProposalErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/accept-proposal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Correct Proposal
 *
 * Corregge la quantità di una riga (l'edit inline della cella) e la chiude come `corrected`: correggere è già una decisione, ma lo stato resta distinto da `accepted`. Richiede una `note` obbligatoria che motiva la correzione — è il feedback usato per migliorare l'algoritmo, legato 1:1 alla correzione. La proposta originale non viene mai sovrascritta. Passare la quantità originale ripristina la riga a pending e svuota quantità corretta, motivazione e valutazione tecnica; in quel caso note può essere vuota. Una correzione diversa dall’originale senza motivazione non vuota risponde correction_note_required. Ogni modifica resta ricostruibile dalla cronologia. Si corregge solo un documento in lavorazione: altrimenti risponde `run_not_editable`. Una quantità oltre 1.000.000 (per esempio un codice incollato nella cella) è rifiutata come `validation_error`. Richiede un account autenticato.
 */
export const poCorrectProposal = <ThrowOnError extends boolean = true>(options: Options<PoCorrectProposalData, ThrowOnError>) => (options.client ?? client).post<PoCorrectProposalResponses, PoCorrectProposalErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/correct-proposal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Accept Proposals
 *
 * Accetta in blocco, in uno di tre modi. Con `ids` accetta le righe selezionate, qualunque sia la segnalazione (la selezione è una scelta esplicita dell'esperto). Con `filters` («Accetta questa vista») accetta le righe che la vista corrente mostra. Con `all: true` («Accetta tutto») accetta ogni riga ancora da rivedere del documento. In ogni caso le righe già decise (accettate o corrette) non vengono toccate: `accepted` conta solo le righe effettivamente accettate ora. Con `ids`, se un id non è una riga del documento non viene accettata nessuna riga (`proposal_not_found`). Si accetta solo su un documento in lavorazione: altrimenti `run_not_editable`. Richiede un account autenticato.
 */
export const poBulkAcceptProposals = <ThrowOnError extends boolean = true>(options: Options<PoBulkAcceptProposalsData, ThrowOnError>) => (options.client ?? client).post<PoBulkAcceptProposalsResponses, PoBulkAcceptProposalsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/bulk-accept-proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Proposal History
 *
 * Cronologia completa di una riga (la cronologia versioni): ogni accettazione, correzione e nota con valore prima/dopo, chi e quando, dalla più vecchia alla più recente. Tre correzioni successive = tre voci: niente va mai perso. actor espone tipo e nome dell'autore registrato in actorId: il nome è null per account anonimizzati o non disponibili, azioni automatiche e operazioni tecniche. Richiede un account autenticato.
 */
export const poGetProposalHistory = <ThrowOnError extends boolean = true>(options: Options<PoGetProposalHistoryData, ThrowOnError>) => (options.client ?? client).post<PoGetProposalHistoryResponses, PoGetProposalHistoryErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-proposal-history',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Distributors
 *
 * Elenca i distributori conosciuti, in ordine alfabetico: le scelte possibili quando si crea un documento limitato ad alcuni distributori. La lista viene dall'ultimo documento generato non ristretto (un documento fallito non conta, anche se archiviato); è vuota finché non ne esiste uno. Richiede un account autenticato.
 */
export const poListDistributors = <ThrowOnError extends boolean = true>(options?: Options<PoListDistributorsData, ThrowOnError>) => (options?.client ?? client).post<PoListDistributorsResponses, PoListDistributorsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-distributors',
    ...options
});

/**
 * List Publishers
 *
 * Elenca le case editrici che trattiamo, dalla più alla meno venduta nella campagna precedente. Serve alla schermata delle esclusive per mostrare anche chi NON è in esclusiva: senza questa lista l'ingrosso si potrebbe solo dedurre da un'assenza. La lista viene dall'ultimo documento generato non ristretto (un documento fallito non conta, anche se archiviato) ed è vuota finché non ne esiste uno. Richiede un account autenticato.
 */
export const poListPublishers = <ThrowOnError extends boolean = true>(options?: Options<PoListPublishersData, ThrowOnError>) => (options?.client ?? client).post<PoListPublishersResponses, PoListPublishersErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-publishers',
    ...options
});

/**
 * Create Export
 *
 * Genera un export di consultazione (`report`, default) o un TXT operativo per Mr.Book (`mrbook`). Richiede un account autenticato. Il report contiene un foglio Excel per editore più un riepilogo complessivo, e un CSV riutilizzabile (codice = ISBN, con la colonna distributore). I filtri del payload rispecchiano quelli della griglia: l'export contiene esattamente le righe con quantità positiva che i filtri lasciano passare. Il TXT Mr.Book contiene solo proposte accettate o corrette, con quantità positiva; conserva gli altri filtri e verifica barcode, fornitore principale e quantità sul catalogo sincronizzato più recente prima di produrre il file. Un catalogo non disponibile o dati non validi fanno fallire l'export senza file scaricabili. Il TXT non contiene ISBN alternativi, intestazione o fornitore: l'import nativo usa il distributore principale del libro. Generare o scaricare il TXT non registra né invia un ordine; l'import in Mr.Book è manuale e non protegge dai doppi import. L'export fotografa lo stato AL MOMENTO della generazione, correzioni incluse. Si esporta un documento generato (in lavorazione, completato o archiviato dopo la generazione): su un documento ancora in generazione o fallito, anche se poi archiviato, risponde `run_not_generated`. I documenti di simulazione a magazzino vuoto non sono esportabili. La generazione è asincrona: monitora con `list-exports` finché `status` è `completed`, poi scarica con `get-export-download`. Se il servizio di elaborazione non è raggiungibile risponde `job_queue_unavailable`: l'export appena creato è già `failed` con il motivo, e si può rifare più tardi. Ogni export resta per sempre nello storico con l'admin che lo ha richiesto. Richiede un account autenticato.
 */
export const poCreateExport = <ThrowOnError extends boolean = true>(options: Options<PoCreateExportData, ThrowOnError>) => (options.client ?? client).post<PoCreateExportResponses, PoCreateExportErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/create-export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Exports
 *
 * Storico di tutti gli export generati (quando, da chi, da quale documento, con che sintesi), dal più recente; ordinabile con `sort`. Richiede un account autenticato. I filtri per documento, stato e autore si combinano e si applicano anche al totale. `list-export-authors` fornisce gli autori disponibili; usa lo storico anche per monitorare un export in generazione.
 */
export const poListExports = <ThrowOnError extends boolean = true>(options: Options<PoListExportsData, ThrowOnError>) => (options.client ?? client).post<PoListExportsResponses, PoListExportsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-exports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Export Authors
 *
 * Elenca gli autori distinti degli export, eventualmente limitati a un documento. Tutti gli admin autenticati possono leggere. Le opzioni comprendono l'intero storico, indipendentemente da pagina e stato, inclusi gli admin eliminati. Gli autori anonimizzati o senza profilo conservano l'id con nome null; gli export senza autore registrato non aggiungono un'opzione. Usa gli id in `filters.generatedByIds` di `list-exports`.
 */
export const poListExportAuthors = <ThrowOnError extends boolean = true>(options: Options<PoListExportAuthorsData, ThrowOnError>) => (options.client ?? client).post<PoListExportAuthorsResponses, PoListExportAuthorsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/list-export-authors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Export Download
 *
 * Restituisce i link di download temporanei di un export completato (Excel e CSV per `report`, solo TXT per `mrbook`; gli altri link sono null). I link scadono dopo pochi minuti: richiedili al momento del download. Richiede un account autenticato.
 */
export const poGetExportDownload = <ThrowOnError extends boolean = true>(options: Options<PoGetExportDownloadData, ThrowOnError>) => (options.client ?? client).post<PoGetExportDownloadResponses, PoGetExportDownloadErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-export-download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Config
 *
 * Legge la configurazione di business corrente: canali degli editori per anno in `esclusiveByYear` (il 2025 mancante è una copia del 2026 da verificare con il cliente), scorte di sicurezza, generazione schedulata e orari di sync. Con `includeHistory` restituisce anche la storia delle modifiche (chi e quando, non il contenuto). Se l'ultima versione salvata non è leggibile da questa release risponde `business_config_invalid`, con la versione e i campi da correggere: salvare una configurazione valida con `update-config` la sostituisce. Richiede settings.manage per leggere impostazioni e cronologia; gli altri permessi non bastano.
 */
export const poGetConfig = <ThrowOnError extends boolean = true>(options: Options<PoGetConfigData, ThrowOnError>) => (options.client ?? client).post<PoGetConfigResponses, PoGetConfigErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Exclusivity Years
 *
 * Legge i canali degli editori e le regioni in esclusiva per anno. Richiede un account autenticato. Restituisce solo gli elenchi annuali: la configurazione generale e la sua cronologia richiedono il permesso di gestione delle impostazioni.
 */
export const poGetExclusivityYears = <ThrowOnError extends boolean = true>(options?: Options<PoGetExclusivityYearsData, ThrowOnError>) => (options?.client ?? client).post<PoGetExclusivityYearsResponses, PoGetExclusivityYearsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-exclusivity-years',
    ...options
});

/**
 * Get Generation Defaults
 *
 * Restituisce solo l'orizzonte di riordino e i giorni di consegna necessari per creare un documento e mostrarne la copertura. Disponibile a ogni admin autenticato, senza settings.manage. Non espone gli altri parametri né la cronologia delle impostazioni.
 */
export const poGetGenerationDefaults = <ThrowOnError extends boolean = true>(options?: Options<PoGetGenerationDefaultsData, ThrowOnError>) => (options?.client ?? client).post<PoGetGenerationDefaultsResponses, PoGetGenerationDefaultsErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-generation-defaults',
    ...options
});

/**
 * Update Config
 *
 * Aggiorna la configurazione di business (invio completo, non parziale, salvo gli elenchi annuali `esclusiveByYear`, conservati dalla versione corrente: usa le operazioni dedicate alle esclusive per modificarli). La modifica ha effetto DALLE PROPOSTE SUCCESSIVE — i documenti già generati non cambiano — ed è tracciata: la storia di `get-config` mostra chi l'ha salvata e quando. Le scelte che influiscono su una proposta vengono citate nella sua motivazione. Funziona anche quando la versione corrente non è più leggibile (`business_config_invalid` su `get-config`): il salvataggio la sostituisce. Modifiche ai vecchi campi `esclusive` e `esclusiveChanges` vengono rifiutate con `exclusivity_annual_update_required`: ricarica la pagina e modifica l'anno desiderato. Richiede settings.manage; lo stesso permesso autorizza lettura e modifica delle impostazioni.
 */
export const poUpdateConfig = <ThrowOnError extends boolean = true>(options: Options<PoUpdateConfigData, ThrowOnError>) => (options.client ?? client).post<PoUpdateConfigResponses, PoUpdateConfigErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/update-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Exclusivity Year
 *
 * Crea l'elenco degli editori per un anno copiando un anno esistente. Richiede un account autenticato. La copia è indipendente e subito utilizzabile: le modifiche successive non cambiano gli altri anni né i documenti già generati. Un anno già presente non viene sovrascritto. Restituisce solo gli elenchi annuali degli editori.
 */
export const poCreateExclusivityYear = <ThrowOnError extends boolean = true>(options: Options<PoCreateExclusivityYearData, ThrowOnError>) => (options.client ?? client).post<PoCreateExclusivityYearResponses, PoCreateExclusivityYearErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/create-exclusivity-year',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Exclusivity Publisher
 *
 * Modifica o aggiunge un editore nell'anno selezionato. Richiede un account autenticato. Regioni vuote indicano ingrosso; almeno una regione indica esclusiva. Cambia solo questa riga e solo questo anno, con effetto sui documenti generati successivamente. Restituisce solo gli elenchi annuali degli editori.
 */
export const poUpdateExclusivityPublisher = <ThrowOnError extends boolean = true>(options: Options<PoUpdateExclusivityPublisherData, ThrowOnError>) => (options.client ?? client).post<PoUpdateExclusivityPublisherResponses, PoUpdateExclusivityPublisherErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/update-exclusivity-publisher',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get System Status
 *
 * Stato del sistema per la dashboard: le tabelle su cui gira la prossima generazione con la loro freschezza e l'ultimo esito dell'agente per ciascuna, la data del dataset con le tabelle indispensabili che gli mancano e quelle rimaste indietro, se un aggiornamento dati è in corso, ultimo contatto e ultimo giro completo dell'agente, esito dell'ultima generazione, avanzamento dell'ultimo «Aggiorna dati ora» e presenza dell'adottato della campagna corrente. Risponde alla domanda “posso fidarmi di quello che vedo?”. Richiede un account autenticato.
 */
export const poGetSystemStatus = <ThrowOnError extends boolean = true>(options?: Options<PoGetSystemStatusData, ThrowOnError>) => (options?.client ?? client).post<PoGetSystemStatusResponses, PoGetSystemStatusErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/get-system-status',
    ...options
});

/**
 * Refresh Data
 *
 * “Aggiorna dati ora”: accoda all'agente il comando di eseguire subito un giro di sincronizzazione. L'agente lo riceve al suo prossimo contatto (entro ~1 minuto) e i dati freschi compaiono dopo il tempo di upload: segui l'avanzamento su `refresh` di `get-system-status`. Se una richiesta è ancora in attesa, viene riaccodata invece di crearne un'altra. Richiede un account autenticato.
 */
export const poRefreshData = <ThrowOnError extends boolean = true>(options?: Options<PoRefreshDataData, ThrowOnError>) => (options?.client ?? client).post<PoRefreshDataResponses, PoRefreshDataErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    security: [
        {
            in: 'cookie',
            name: 'x-backoffice-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/po/refresh-data',
    ...options
});

/**
 * Health Check
 *
 * Returns `Healthy` (200) when every essential service answered its latest check, `Unhealthy` (500) otherwise, including when the server can no longer serve database requests in time. Public. Right after startup it answers `Unhealthy` until the first checks complete.
 */
export const healthCheck = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health-check',
    ...options
});

/**
 * Services
 *
 * Returns the health check of the server services
 */
export const healthCheckServices = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckServicesData, ThrowOnError>) => (options?.client ?? client).get<unknown, HealthCheckServicesErrors, ThrowOnError, 'data'>({
    responseStyle: 'data',
    url: '/health-check/services',
    ...options
});
